import { newSpecPage } from '@stencil/core/testing'
import { CobaltCheckbox } from '../cobalt-checkbox'

describe('cobalt-checkbox', () => {
  it('should render checkbox element unchecked', async () => {
    const page = await newSpecPage({
      components: [CobaltCheckbox],
      html: '<cobalt-checkbox></cobalt-checkbox>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-checkbox>
        <core-checkbox format="right"></core-checkbox>
      </cobalt-checkbox>
    `)
  })
  it('should render checkbox element checked', async () => {
    const page = await newSpecPage({
      components: [CobaltCheckbox],
      html: '<cobalt-checkbox checked></cobalt-checkbox>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-checkbox checked="">
        <core-checkbox checked="" format="right"></core-checkbox>
      </cobalt-checkbox>
    `)
  })
  it('should change format to left', async () => {
    const page = await newSpecPage({
      components: [CobaltCheckbox],
      html: '<cobalt-checkbox format="left"></cobalt-checkbox>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-checkbox format="left">
        <core-checkbox format="left"></core-checkbox>
      </cobalt-checkbox>
    `)
  })
})
